import styled, { keyframes } from "styled-components";
import { Colors } from "../../../shared/colors/colors";

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  margin-top: 10px;
  gap: 16px;
  width: 90vw;
`;

export const ContainerButtons = styled.div`
  display: flex;
  gap: 10px;
`;